import Vue from 'vue'
import VueRouter from 'vue-router';
import { BootstrapVue } from 'bootstrap-vue';
import axios from 'axios';
import VueFeather from 'vue-feather';
import vWow from 'v-wow';
import VueCarousel from 'vue-carousel';
import Toasted from 'vue-toasted';
import App from './App.vue'
import './assets/style/custom.scss';
import { router } from './router';
import store from './store';
import VueAnalytics from 'vue-analytics';
//import VueSelectImage from 'vue-select-image';
//require ('vue-select-image/dist/vue-select-image.css');

Vue.config.productionTip = false

Vue.use(BootstrapVue);
Vue.use(VueFeather);
Vue.use(axios);
Vue.use(VueRouter);
Vue.use(vWow);
Vue.use(VueCarousel);
Vue.use(Toasted);
Vue.use(VueAnalytics, {
  id: 'UA-167910888-1',
  router,
});
//Vue.use(VueSelectImage);

export default {
  methods: {
    disableTracking: function() {
      this.$ga.disable();
      alert('Tracking disabled');
    }
  }
};

new Vue({
    el: '#app',
  store,
  router,

  render: h => h(App),
}).$mount('#app')
